export class Yard {
    id: number;
    key: string;
    name: string;
    timezone: string;
}
